import React, { useState, useEffect } from "react";
import { makeStyles, withStyles, useTheme } from "@material-ui/core/styles";
import { Box, Typography } from "@material-ui/core";
import { useHistory } from "react-router-dom";

import FooterWithContent from "../../components/StaticComp/Footer/FooterWithContent";

export default function PrivacyPolicy() {
  const classes = useStyles();
  const theme = useTheme();
  let history = useHistory();

  return (
    <div>
      <div className={classes.root}>
        <Box className={classes.partition}>
          <Typography variant="body1">
            <p>
              As used herein, “PocketBits.in or Company” refers to the holding
              company of PocketBits.in being Defacto Technologies Private
              Limited (‘Company’), a private limited company incorporated under
              the laws of India and having its registered office at Plot No. 65,
              Sno807/1/3/20, Deepali Nagar, Agra Road, Nashik, Maharashtra,
              India, 422009 its owners, directors, investors, employees or other
              related parties. Where the context so permits, depending upon
              context, “PocketBits” may also refer to the services, products,
              website, content or other materials (collectively, “Materials”)
              provided by the Company.
            </p>
            <p>
              This privacy policy governs our collection, processing, use and
              storage of your personal information. By using the website
              www.pocketbits.in (“Website”), you consent to the PocketBits
              privacy policy and data practices (“Privacy Policy”). We may
              periodically make changes to the Privacy Policy. While PocketBits
              will attempt to notify you of these changes, it is your
              responsibility to review this privacy policy on regular basis and
              remain informed of any changes. Your continued use of the Website
              following the change in the Privacy Policy signifies that you
              accept and agree to such changes.
            </p>
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography
            id="applicable"
            variant="h3"
            className={classes.subHeading}
          >
            Your Personal Information
          </Typography>
          <Typography variant="body1">
            <p>
              PocketBits may collect your personal information while you access
              the Website. While opening an account with us we may collect your
              contact information including name, address, phone, email, etc.;
              information regarding your transactions and trading; bank account;
              and information pertaining to your IP address and the device or
              computer used by you for the purpose.
            </p>
            <p>
              PocketBits may collect, disclose, process, transfer, use your
              personal information for the following purposes:
            </p>
          </Typography>
          <ul class="myUl">
            <li>
              <Typography variant="body1">To process transactions,</Typography>
            </li>
            <li>
              <Typography variant="body1">
                To send periodic emails and SMS with updates, promotions,
                company news, and notices regarding changes to policies,
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Customize, measure, and improve PocketBits Service and the
                content and layout of our Website and applications,
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                To analyze use of the Website,
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                Prevent potentially prohibited or illegal activities, and
              </Typography>
            </li>
            <li>
              <Typography variant="body1">
                To undertake a verification of your identity with third party
                electronic identification providers.
              </Typography>
            </li>
          </ul>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Cookies
          </Typography>
          <Typography variant="body1">
            We use cookies on our website to collect data about your visits and
            to allow you to navigate from page to page without having to
            re-login each time, count visits, and see which areas and features
            of our website are popular. We do not link the information we store
            in cookies to any information you submit while on our website. We
            may also use the data collected via cookies to tailor advertisements
            to you and to track the popularity of our website. Our use of
            cookies and other technologies may allow us and third parties to
            collect information about your browsing activities over time and
            across different websites following your use of our services.
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Analytics
          </Typography>
          <Typography variant="body1">
            <p>
              When you visit our website, we use third party analysis tools to
              collect data about your computer and Internet connection. That
              information includes the IP address of your computer and/or
              Internet service provider, when you access our website, the
              Internet address of websites from which you link to our website
              and from which you came before landing on our website, the browser
              that you are using, and your movements and preferences on our
              website. All of this information is used internally for the
              purpose of understanding how our website is being used and
              improving our website.
            </p>
            <p>
              When you visit our website, we use third party analysis tools to
              collect data about your computer and Internet connection. That
              information includes the IP address of your computer and/or
              Internet service provider, when you access our website, the
              Internet address of websites from which you link to our website
              and from which you came before landing on our website, the browser
              that you are using, and your movements and preferences on our
              website. All of this information is used internally for the
              purpose of understanding how our website is being used and
              improving our website.
            </p>
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Do Not Track
          </Typography>
          <Typography variant="body1">
            Our Service currently does not respond to “Do Not Track” signals and
            operates as described in this Privacy Policy whether or not a Do Not
            Track signal is received. If we do so in the future, we will
            describe how we do so in this Privacy Policy
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            How We Protect The Data We Collect
          </Typography>
          <Typography variant="body1">
            We use reasonable physical, electronic, and procedural safeguards to
            protect the personal information that we obtain from you from loss,
            misuse, and unauthorized access, disclosure, alteration, and
            destruction. Please note that we are not responsible for the
            security of any data you are transmitting over the Internet, or any
            data you are storing, posting, or providing directly to a third
            party’s website, which is governed by that party’s policies. Please
            note that no method of transmission over the Internet or method of
            electronic storage is 100% secure. If you have further questions
            about security, you can contact us at support@pocketbits.in
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Data Retention
          </Typography>
          <Typography>
            <p>
              If you wish to close your PocketBits account altogether, please
              let us know by submitting a request to support@pocketbits.in. We
              may retain information about you in our databases for as long as
              your account is active or as needed to provide you services and in
              accordance with applicable laws. Our retention and use of your
              information will be as necessary to comply with our legal
              obligations, resolve disputes, and enforce our agreements.
            </p>
            <p>
              If you wish to close your PocketBits account altogether, please
              let us know by submitting a request to support@pocketbits.in. We
              may retain information about you in our databases for as long as
              your account is active or as needed to provide you services and in
              accordance with applicable laws. Our retention and use of your
              information will be as necessary to comply with our legal
              obligations, resolve disputes, and enforce our agreements.
            </p>
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Disclosure And Transfer Of Personal Information
          </Typography>
          <Typography>
            <p>
              We do not share any information related to users with any third
              party for uses like marketing and promotional purpose. Stored
              personal information is available only to the user (for editing
              purposes), customer service personnel, verification department and
              to administrators and consultants, and third party entities and
              service providers who are bound by non-disclosure agreements.
            </p>
            <p>
              However, we do share information with law enforcement and
              government officials when we are compelled to do so by a court
              order or similar legal procedure.
            </p>
            <p>
              You also agree that PocketBits shall be free to transfer/disclose
              any information shared by you with PocketBits, to a related party
              or to an affiliate or to any entity controlled by the promoters of
              PocketBits. We may also transfer your information during sale of
              assets or business to another company, de-merger into another
              company, while getting acquired by another company or getting
              merged with another company.
            </p>
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Changing Personal Information
          </Typography>
          <Typography variant="body1">
            {`You may access your personal information in order to make changes or
            corrections by visiting Profile -> Settings. However when you change
            any personal information, you will need to provide the documents
            again and go through verification procedure before your changes come
            to effect.`}
          </Typography>
        </Box>
        <Box className={classes.partition}>
          <Typography variant="h3" className={classes.subHeading}>
            Contact Us
          </Typography>
          <Typography variant="body1">
            If you have any questions relating to the Privacy Policy, please
            contact us at support@pocketbits.in
          </Typography>
        </Box>
      </div>
      <FooterWithContent />
    </div>
  );
}

const useStyles = makeStyles((theme) => ({
  root: {
    color: "#fff",
    width: "70%",
    margin: "0 auto",
    marginTop: "80px",
  },
  subHeading: {
    paddingBottom: "20px",
    textTransform: "capitalize",
  },
  partition: {
    paddingBottom: "20px",
  },
}));
